module.exports = __webpack_public_path__ + "img/back_address_active4.bf303941.png";